var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowChartAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9C14.3937 9 16.3945 7.82259 16.8849 6.25H21C21.1381 6.25 21.25 6.36193 21.25 6.5V11C21.25 11.1381 21.1381 11.25 21 11.25H20.3107L20.5303 11.0303C20.8232 10.7374 20.8232 10.2626 20.5303 9.96967C20.2374 9.67678 19.7626 9.67678 19.4697 9.96967L17.9697 11.4697C17.6768 11.7626 17.6768 12.2374 17.9697 12.5303L19.4697 14.0303C19.7626 14.3232 20.2374 14.3232 20.5303 14.0303C20.8232 13.7374 20.8232 13.2626 20.5303 12.9697L20.3107 12.75H21C21.9665 12.75 22.75 11.9665 22.75 11V6.5C22.75 5.5335 21.9665 4.75 21 4.75H16.8849C16.3945 3.17741 14.3937 2 12 2C9.23858 2 7 3.567 7 5.5C7 7.433 9.23858 9 12 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H16C16.5523 15 17 14.5523 17 14V10C17 9.44772 16.5523 9 16 9H12H8C7.44772 9 7 9.44772 7 10V11.25H3C2.0335 11.25 1.25 12.0335 1.25 13V17.5C1.25 18.4665 2.0335 19.25 3 19.25H3.68934L3.46967 19.4697C3.17678 19.7626 3.17678 20.2374 3.46967 20.5303C3.76256 20.8232 4.23744 20.8232 4.53033 20.5303L6.03033 19.0303C6.32322 18.7374 6.32322 18.2626 6.03033 17.9697L4.53033 16.4697C4.23744 16.1768 3.76256 16.1768 3.46967 16.4697C3.17678 16.7626 3.17678 17.2374 3.46967 17.5303L3.68934 17.75H3C2.86193 17.75 2.75 17.6381 2.75 17.5V13C2.75 12.8619 2.86193 12.75 3 12.75H7V14C7 14.5523 7.44772 15 8 15H12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15L17 18.5L12 22L7 18.5L12 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowChartAlt);
export default __webpack_public_path__ + "static/media/flow-chart-alt.c688061f430103b84a3793abf95f6e47.svg";
export { ForwardRef as ReactComponent };